<div class="skeleton-card">
    <div class="skeleton-texts">
        <span class="ra-skeleton line-title"></span>
        <span class="ra-skeleton line-sub"></span>
    </div>

    <span class="ra-skeleton chip"></span>
</div>
